import { render, staticRenderFns } from "./locationDetail.vue?vue&type=template&id=56cf0c0a&scoped=true"
import script from "./locationDetail.vue?vue&type=script&lang=js"
export * from "./locationDetail.vue?vue&type=script&lang=js"
import style0 from "./locationDetail.vue?vue&type=style&index=0&id=56cf0c0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf0c0a",
  null
  
)

export default component.exports